import { render, staticRenderFns } from "./App.vue?vue&type=template&id=b2f0bc4e&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./App.vue?vue&type=style&index=1&id=b2f0bc4e&scoped=true&lang=scss&"
import style2 from "./App.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f0bc4e",
  null
  
)

export default component.exports